import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Replicates AngularJS GridFactory.getDataCustom for Notifications Engine.
 * From notifCtrl.js: viewNotifURL (nn30ik, 187), viewNotifSetURL (fuwfzt, 189), maintenanceURL (6zlcxh, 190).
 */
@Injectable({ providedIn: 'root' })
export class NotifEngineService {

  private readonly CONFIGS: Record<number, { action_code: string; grid_id: number }> = {
    1: { action_code: 'nn30ik', grid_id: 187 },
    2: { action_code: 'fuwfzt', grid_id: 189 },
    3: { action_code: '6zlcxh', grid_id: 190 },
  };

  constructor(private http: HttpClient) {}

  loadGridData(
    baseUrl: string,
    globalService: any,
    filterParams: any,
    notifType: number,
    args?: { start_dt?: string; end_dt?: string }
  ): Observable<any> {
    const config = this.CONFIGS[notifType] || this.CONFIGS[1];
    const url = `${baseUrl}/loadGridJson?action_code=${config.action_code}&grid_id=${config.grid_id}`;
    const globalParams = globalService?.globalParams ?? globalService ?? {};
    const params = { ...globalParams, ...filterParams, ...(args || {}) };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post<any>(url, params, {
      headers,
      withCredentials: true,
    });
  }
}
